<div class="pdf-preview-wrapper">
  <!-- Reusable Header Component -->
  <app-preview-header
    [fileData]="model"
    [showMetadata]="true"
    [showDownload]="true"
    [showPrint]="true"
    (download)="downloadMedia($event)"
    (print)="printPdf()"
    (close)="closeDialog()">
  </app-preview-header>

  <!-- PDF Controls Toolbar -->
  <div class="pdf-toolbar">
    <!-- Page Navigation -->
    <div class="toolbar-group">
      <button class="toolbar-btn" (click)="previousPage()" [disabled]="currentPage === 1" matTooltip="Previous Page">
        <i class="fas fa-chevron-left"></i>
      </button>
      <div class="page-indicator">
        <span class="page-label">Page</span>
        <input type="number" class="page-input" [(ngModel)]="currentPage" (change)="goToPage(currentPage)" min="1" />
      </div>
      <button class="toolbar-btn" (click)="nextPage()" matTooltip="Next Page">
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  </div>

  <!-- PDF Viewer Body -->
  <div class="pdf-body">
    <!-- Loading Overlay -->
    @if (isLoading) {
      <app-preview-loading [message]="'Loading PDF...'" [overlay]="true"></app-preview-loading>
    }

    <!-- PDF Iframe -->
    <iframe
      [src]="getPdfUrl()"
      class="pdf-iframe"
      (load)="onLoad()"
      frameborder="0"
      [attr.aria-label]="'PDF viewer for ' + model?.original_name">
      <p>Your browser does not support PDF preview. <a [href]="getMediaUrl()" download>Download PDF</a></p>
    </iframe>
  </div>
</div>
